export const errorMessages: { [key: string]: string } = {
  InvalidPasswordException: 'הסיסמה לא ארוכה מספיק',
  UserNotFoundException: 'משתמש לא נמצא',
  UserNotConfirmedException: 'sd',
  UsernameExistsException: 'המשתמש כבר קיים',
  NotAuthorizedException: 'שם המשתמש או הסיסמה שגויים',
  default: 'אירעה שגיאה בלתי צפויה, נסה שוב מאוחר יותר',
  'Invalid phone number format.': 'פורמט מספר טלפון לא חוקי',
  'User already exists': 'המשתמש כבר קיים',
  'Incorrect username or password.': 'שם משתמש או סיסמה שגויים',
};
